export default __webpack_public_path__ + "static/media/about-page-img.e2536f98.jpg";